import React from 'react';
import cn from 'classnames';
import Button from '@material-ui/core/Button';
import stylesParent from '../../frame.module.scss';
import styles from '../../styles/unstake/unstake-information.module.scss';
import { useGetTheme } from '../../../../../hooks/useGetTheme';

import PropTypes from 'prop-types';

const Information = ({
  continueClick,
  unstakeImmediatelyClick,
  firstDescription,
  secondDescription,
  fee,
}) => {
  const colors = useGetTheme();

  const claimFee = fee || '2';

  return (
    <div className={cn(stylesParent.cardContent, styles.unstaking)} style={{ color: colors.text }}>
      <div className={styles.title}>Withdrawal Timer Reset!</div>
      <div className={styles.description}>
        {firstDescription ??
          `If you are currently unstaking and decide to unstake more tokens half way through, the timer
          will be reset to 8 days, and you will be able to withdraw both set of tokens after 8 days.`}
      </div>
      <Button
        onClick={continueClick}
        variant='contained'
        color='secondary'
        className={cn(stylesParent.cardFooterControlsButton, styles.button)}
      >
        Continue
      </Button>
      <div className={styles.description}>
        <span>IMPORTANT:</span>&nbsp;
        <b>
          {secondDescription ??
            `You are able to unstake your tokens immediately by paying a ${claimFee}% fee on your current unstaking amount.`}
        </b>
      </div>
      <Button
        onClick={unstakeImmediatelyClick}
        variant='contained'
        color='secondary'
        className={cn(stylesParent.cardFooterControlsButton, styles.button)}
      >
        Unstake Immediately
      </Button>
    </div>
  );
};

Information.propTypes = {
  continueClick: PropTypes.func.isRequired,
  unstakeImmediatelyClick: PropTypes.func.isRequired,
  firstDescription: PropTypes.string,
  secondDescription: PropTypes.string,
  claimFee: PropTypes.string,
};

export default Information;
